// shared-lib/labor/deviceTypes.js
//
// Electrical device object type → the work item that installs it. The
// types are the web's `utils/electricalDevices.js` registry
// (claude-docs/2026-10-06-supply-and-devices-plan.md): exhaust fans since
// 2026-10-19, smoke and CO alarms since 2026-10-25. Its own module so
// `qualifiers.js` and `devices.js` can both read it without a cycle.

const DEVICE_MAP = Object.freeze({
  outlet: 'install-outlet',
  'surface-outlet': 'install-outlet',
  'gfci-outlet': 'install-gfci-outlet',
  'outlet-240v': 'install-240v-outlet',
  switch: 'install-switch',
  '3way': 'install-3way-switch',
  dimmer: 'install-dimmer',
  'exhaust-fan': 'install-exhaust-fan',
  'smoke-detector': 'install-smoke-detector',
});

/** The install work item for an object's type, or null for a non-device. */
const deviceWorkItemFor = (obj) =>
  DEVICE_MAP[String(obj?.type || '').toLowerCase()] ?? null;

module.exports = { DEVICE_MAP, deviceWorkItemFor };
